import { Fragment } from 'react'
import List from '@mui/material/List'
import EstimationItem from './Item'

export default function EstimationsList({estimations, itemsOnly=false}) {
    const Container = itemsOnly ? Fragment : List

    return (
        <Container>
            {estimations.map(est =>
                <EstimationItem
                    key={est.id}
                    item={est}
                />
            )}
        </Container>
    )
}
